import { useTranslation } from 'react-i18next';
import { ColumnDef } from '@tanstack/react-table';
import { TableCell } from '@anytag/shared-atoms';
import { formatIntNumber } from '@anytag/shared-utils';
import { usePostDetailsParam } from '@anytag/shared-hooks';
import { InstagramReelPostItem, InstagramReelPostSortField } from '@anytag/graphql';

export const useInfluencerInstagramReelPostsListTable = () => {
  const { t } = useTranslation();
  const { setPostDetailsParam } = usePostDetailsParam();

  const columns: ColumnDef<InstagramReelPostItem>[] = [
    {
      accessorKey: 'post',
      meta: { sticky: true },
      header: t<string>('HeaderColumn.Post'),
      cell: ({ row }) => (
        <TableCell.Post
          title={row.original.content || ''}
          thumbnail={row.original.thumbnail || ''}
          onClick={() => setPostDetailsParam(row.original.id)}
        />
      )
    },
    {
      accessorKey: 'views',
      header: t<string>('HeaderColumn.View'),
      meta: { align: 'right', help: t<string>('Tooltip.ViewHelp'), sortField: InstagramReelPostSortField.VIEWS },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.views)} />
    },
    {
      accessorKey: 'reach',
      header: t<string>('HeaderColumn.Reach'),
      meta: { align: 'right', help: t<string>('Tooltip.ReachPostHelp'), sortField: InstagramReelPostSortField.REACH },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.reach)} />
    },
    {
      accessorKey: 'likes',
      header: t<string>('HeaderColumn.Like'),
      meta: { align: 'right', help: t<string>('Tooltip.LikeHelp'), sortField: InstagramReelPostSortField.LIKES },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.likes)} />
    },
    {
      accessorKey: 'comments',
      header: t<string>('HeaderColumn.Comment'),
      meta: { align: 'right', help: t<string>('Tooltip.CommentHelp'), sortField: InstagramReelPostSortField.COMMENT },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.comments)} />
    },
    {
      accessorKey: 'shares',
      header: t<string>('HeaderColumn.share'),
      meta: { align: 'right', help: t<string>('Tooltip.shareHelp'), sortField: InstagramReelPostSortField.SHARES },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.shares)} />
    },
    {
      accessorKey: 'saved',
      header: t<string>('HeaderColumn.Save'),
      meta: { align: 'right', help: t<string>('Tooltip.SaveHelp'), sortField: InstagramReelPostSortField.SAVED },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.saved)} />
    },
    {
      accessorKey: 'postDate',
      header: t<string>('HeaderColumn.Post date'),
      meta: { help: t<string>('Tooltip.PostDateHelp'), sortField: InstagramReelPostSortField.POST_DATE },
      cell: ({ row }) => <TableCell.Date className="min-w-20" value={row.original.postDate} />
    }
  ];

  return { columns };
};
